import React, { useState } from "react";
import "./Header.css";
import { Layout, Menu, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useBreakpoint from "../utils/hooks/useBreakpoint";

const { Header } = Layout;

export default function CustomHeader({ selectedKeys }) {
  const { t } = useTranslation("user");
  const { isMobile } = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  const menuItems = (
    <>
      <Menu.Item key="createIssue">
        <Link to="/user/create-issue" onClick={isMobile ? closeDrawer : undefined}>
          {t("header.newTicket")}
        </Link>
      </Menu.Item>
      <Menu.Item key="overview">
        <Link to="/user/overview" onClick={isMobile ? closeDrawer : undefined}>
          {t("header.overview")}
        </Link>
      </Menu.Item>
    </>
  );

  return (
    <Header className="user-header">
      <div className="logo-container">
        <Link to="/user/overview">
          <img className="logo" src="/AveveLogo.png" alt="Aveve logo" />
        </Link>
      </div>

      {isMobile ? (
        <>
          <Button
            className="mobile-menu-button"
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#fff" }} />}
            onClick={showDrawer}
          />
          <Drawer
            title={t("header.menu", "Menu")}
            placement="right"
            onClose={closeDrawer}
            open={drawerVisible}
            className="mobile-drawer"
          >
            <Menu theme="dark" mode="vertical" selectedKeys={selectedKeys}>
              {menuItems}
            </Menu>
          </Drawer>
        </>
      ) : (
        <Menu theme="dark" mode="horizontal" selectedKeys={selectedKeys}>
          {menuItems}
        </Menu>
      )}
    </Header>
  );
}
